/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ResolveExcludedPeopleByLinkedinUrlsRequest {
  /**
     * @minItems 1
     * @maxItems 500
     */
  linkedin_urls: string[];
}
